// Find multiple options by their values (for multi-selects)
export function findOptionsByValues(options, values) {
  if (!Array.isArray(options) || !values) return [];
  const valueArray = Array.isArray(values)
    ? values
    : values.split(",").map((v) => v.trim());
  return valueArray
    .map((val) => options.find((opt) => String(opt.value) === String(val)))
    .filter(Boolean);
}

// Build filter data object from URL search params
export function buildFilterFromParams(params, userOptions, statusOptions) {
  const filterData = {};
  if (params.rateCardId) filterData.rateCardId = params.rateCardId;
  if (params.rateCardNameKeywords)
    filterData.rateCardNameKeywords = params.rateCardNameKeywords;
  if (params.keywordMatchType)
    filterData.keywordMatchType = params.keywordMatchType;
  if (params.tprDisplay) filterData.tprDisplay = params.tprDisplay;
  if (params.users && userOptions.length > 0) {
    filterData.users = findOptionsByValues(userOptions, params.users);
  }
  if (params.status && statusOptions.length > 0) {
    filterData.status = findOptionsByValues(statusOptions, params.status);
  }
  if (params.pageSize) {
    filterData.pageSize = Number(params.pageSize);
  }
  return filterData;
}

// Serialize multi-select value to comma-separated string of IDs
function serializeMultiSelect(value) {
  if (!value || (Array.isArray(value) && value.length === 0)) return "";
  if (Array.isArray(value)) {
    return value.map((v) => v?.value ?? v).join(",");
  }
  return value?.value ?? value ?? "";
}

// Clean and normalize the Rate Card filter object for API requests
export function cleanRateCardFilter(filter, rateCardsRange, rateCardsSort) {
  const filtered = {};

  // Text fields
  if (filter.rateCardId) filtered.rateCardId = filter.rateCardId;
  if (filter.rateCardNameKeywords)
    filtered.rateCardNameKeywords = filter.rateCardNameKeywords;

  // Radio fields
  if (filter.keywordMatchType)
    filtered.keywordMatchType = filter.keywordMatchType;
  if (filter.tprDisplay) filtered.tprDisplay = filter.tprDisplay;

  // Multi-select fields
  const usersVal = serializeMultiSelect(filter.users);
  if (usersVal) filtered.users = usersVal;

  const statusVal = serializeMultiSelect(filter.status);
  if (statusVal) filtered.status = statusVal;

  // Pagination
  if (rateCardsRange) filtered.rateCardsRange = rateCardsRange;
  if (rateCardsSort) filtered.rateCardsSort = rateCardsSort;
  if (filter.pageSize) filtered.pageSize = filter.pageSize;

  return filtered;
}
